var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#007FCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0094 8.33934L9.66195 6.99184L10.6359 6.01734L11.9829 7.36434L11.0094 8.33934ZM12.702 6.66884L12.7014 6.66834L11.3324 5.29934C10.9619 4.92984 10.3254 4.91234 9.97445 5.26484L5.47645 9.76284C5.31345 9.92534 5.21245 10.1413 5.19145 10.3698L5.00195 12.4548C4.98895 12.6023 5.04145 12.7483 5.14645 12.8533C5.24095 12.9478 5.36845 12.9998 5.49995 12.9998C5.51545 12.9998 5.53045 12.9993 5.54545 12.9978L7.63045 12.8083C7.85945 12.7873 8.07495 12.6868 8.23745 12.5243L12.7359 8.02584C13.0999 7.66084 13.0844 7.05184 12.702 6.66884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/EditCircle.599f3c55631e961766443d3b246c7a0a.svg";
export { ForwardRef as ReactComponent };